<div class="contract-signing-container">
  <h3>{{ 'INTL_SIGN_DOCUMENTS' | translate }}</h3>
  <p class="subtitle">{{ 'INTL_ONBOARDING_CONTRACT_SUBTITLE' | translate }}</p>

  <div class="status-card" *ngIf="busy && !signingUnavailable">
    <mat-spinner diameter="20"></mat-spinner>
    <span>{{ 'INTL_ONBOARDING_CONTRACT_WAITING' | translate }}</span>
  </div>

  <div class="status-card error" *ngIf="signingUnavailable">
    <mat-icon>error</mat-icon>
    <span>{{ 'INTL_ONBOARDING_CONTRACT_SIGNING_UNAVAILABLE' | translate }}</span>
  </div>

  <div *ngIf="(embedUrl || embedHtml) && !signingUnavailable" class="signing-viewport">
    <iframe
      *ngIf="embedUrl"
      class="signing-frame"
      [src]="embedUrl"
      title="{{ 'INTL_SIGN_DOCUMENTS' | translate }}"
    ></iframe>

    <div *ngIf="embedHtml && !embedUrl" class="signing-html" [innerHTML]="embedHtml"></div>
  </div>

  <div class="actions">
    <button
      mat-stroked-button
      type="button"
      [disabled]="busy"
      (click)="onCancel()"
    >
      {{ 'INTL_CANCEL' | translate }}
    </button>
    <button
      *ngIf="signingUnavailable"
      mat-stroked-button
      type="button"
      [disabled]="busy"
      (click)="onRetry()"
    >
      {{ 'INTL_SEPA_RETRY_SETUP' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="busy || signingUnavailable"
      (click)="onContinue()"
    >
      <mat-spinner *ngIf="busy" diameter="16" class="button-spinner"></mat-spinner>
      <span *ngIf="!busy">{{ 'INTL_CONTINUE_SIGNING' | translate }}</span>
    </button>
  </div>
</div>
